/* eslint-disable no-unused-vars */
import { Grid, Stack } from '@mui/joy';
import { useState } from 'react';
import { TopicDetailsContent } from './MainContent';
import TopicContentLeft from './TopicContentLeft';

const TopicDetailIndex = () => {
  const [editTopicModalOpen, setEditTopicModalOpen] = useState(false);

  return (
    <Grid
      container
      sx={{
        minHeight: '100vh',
        padding: '1rem',
      }}
      gap={2}
    >
      <Grid xs={12} lg={3}>
        <TopicContentLeft />
      </Grid>

      <Grid xs={12} lg={6}>
        <Stack spacing={2}>
          <TopicDetailsContent
            showModal={editTopicModalOpen}
            setModalOpen={setEditTopicModalOpen}
          />
        </Stack>
      </Grid>
      <Grid xs={0} lg={3} />
    </Grid>
  );
};

export default TopicDetailIndex;
